<div class="container-fluid">
    <div class="h4 justify-content-between d-flex">
        Total Commission: {{totalFECommission + totalBECommission | currency}}
        <report-drop-down [panel]="'Commission'" [module]="'Sales'" [saleId]="saleId"></report-drop-down>
    </div>
    <div class="row">
        <form [formGroup]="form" class="w-100">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="justify-content-between d-flex">
                            Front-End Commission
                            <span>Total Commission: {{totalFECommission | currency}}</span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-8">
                                <ng-container formArrayName="frontEnd">
                                    <table class="table table-sm p-1">
                                        <thead>
                                            <tr>
                                                <th>Employee</th>
                                                <th>Rate</th>
                                                <th>Flat</th>
                                                <th>Override</th>
                                                <th>Actual</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @for (frontEndForm of frontEndList.controls; track frontEndForm; let i = $index) {
                                            <tr [formGroup]="frontEndForm">
                                                <td>
                                                    <select class="form-control form-control-sm" formControlName="employeeContactId" name="employeeContactId" id="employeeContactId" (change)="computeCommission()">
                                                        @for (employee of employees; track employee) {
                                                        <option [value]="employee.id" [id]="employee.id">{{employee.name}}</option>
                                                        }
                                                    </select>
                                                </td>
                                                <td><percent-input [control]="frontEndForm.get('percentage')"></percent-input></td>
                                                <td><currency-input [control]="frontEndForm.get('flat')"></currency-input></td>
                                                <td><currency-input [control]="frontEndForm.get('overRideAmount')"></currency-input></td>
                                                <td><currency-input [control]="frontEndForm.get('actualAmount')"></currency-input></td>
                                                <td><button class="btn btn-sm" (click)="discard(frontEndForm.get('id'), i, 'frontEnd')"><span class="uil-trash text-danger"></span></button></td>
                                            </tr>
                                            }
                                        </tbody>
                                    </table>
                                </ng-container>
                                <button class="btn btn-sm btn-primary" (click)="addSalesPerson('frontEnd')">Add Salesperson</button>
                            </div>
                            <div class="col-md-4">
                                <h5>Profit(s)</h5>
                                <ul>
                                    <li>
                                        <span>Subject to Commission</span>
                                        <input class="form-control form-control-sm text-right" [value]="frontEndCommission | currency" disabled />
                                    </li>
                                    <li>
                                        <span>Down Payment</span>
                                        <input class="form-control form-control-sm text-right" [value]="initialDown | currency" disabled />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="justify-content-between d-flex">
                            Back-End Commission
                            <span>Total Commission: {{ totalBECommission | currency }}</span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-8">
                                <ng-container formArrayName="backEnd">
                                    <table class="table table-sm p-1">
                                        <thead>
                                            <tr>
                                                <th>Employee</th>
                                                <th>Rate</th>
                                                <th>Flat</th>
                                                <th>Override</th>
                                                <th>Actual</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @for (backEndForm of backEndList.controls; track backEndForm; let i = $index) {
                                            <tr [formGroup]="backEndForm">
                                                <td>
                                                    <select class="form-control form-control-sm" formControlName="employeeContactId" name="employeeContactId" id="employeeContactId" (change)="computeCommission()">
                                                        @for (employee of employees; track employee) {
                                                        <option [value]="employee.id" [id]="employee.id">{{employee.name}}</option>
                                                        }
                                                    </select>
                                                </td>
                                                <td><percent-input [control]="backEndForm.get('percentage')"></percent-input></td>
                                                <td><currency-input [control]="backEndForm.get('flat')"></currency-input></td>
                                                <td><currency-input [control]="backEndForm.get('overRideAmount')"></currency-input></td>
                                                <td><currency-input [control]="backEndForm.get('actualAmount')"></currency-input></td>
                                                <td><button class="btn btn-sm" (click)="discard(backEndForm.get('id'), i, 'backEnd')"><span class="uil-trash text-danger"></span></button></td>
                                            </tr>
                                            }
                                        </tbody>
                                    </table>
                                </ng-container>
                                <button class="btn btn-sm btn-primary" (click)="addSalesPerson('backEnd')">Add Salesperson</button>
                            </div>
                            <div class="col-md-4">
                                <h5>Profit(s)</h5>
                                @if (backEndCommission && backEndCommission.products) {
                                <ul>
                                    <li>
                                        <span>Subject to Commission</span>
                                        <input class="form-control form-control-sm text-right" [value]="backEndCommission.total | currency" disabled />
                                    </li>
                                    @for (product of backEndCommission.products | keyvalue; track product.key) {
                                    <li>
                                        <span>{{product.key | titlecase }} Profit</span>
                                        <input class="form-control form-control-sm text-right" [value]="product.value" disabled />
                                    </li>
                                    }
                                </ul>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>